import { TextField, Button, InputAdornment, IconButton } from "@mui/material";
import { useController } from "react-hook-form";
import { useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file); // Convertir le fichier en base64
  });
};

const CustomFileField = ({ field, control, multiple, label }) => {
  const inputRef = useRef();
  const {
    field: fieldProps,
    fieldState: { error },
  } = useController({
    control,
    name: field.name,
  });

  const handleChange = async (e) => {
    const files = Array.from(e.target.files).map(async (file) => {
      try {
        const base64File = await convertFileToBase64(file);
        return {
          name: file.name, // Le nom du fichier
          content_type: file.type, // Le type MIME du fichier
          size: file.size, // La taille du fichier en octets
          content: base64File, // Le contenu du fichier en base64
        };
      } catch (error) {
        console.error("File conversion to base64 failed:", error);
      }
    });

    if (!multiple) {
      return fieldProps.onChange((await files[0]) || null);
    } else {
      return fieldProps.onChange(await Promise.all(files));
    }
  };

  return (
    <div style={{ display: field.hidden ? "none" : "block" }}>
      <TextField
        value={fieldProps.value?.name || ""}
        label={label || field.label}
        variant="outlined"
        fullWidth
        disabled
        error={!!error}
        helperText={JSON.stringify(error?.message) || field.help_text || ""}
        sx={{ mt: 1 }}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                {fieldProps.value && (
                  <IconButton
                    color="error"
                    onClick={() => {
                      inputRef.current.value = "";
                      const event = new Event("change", {
                        bubbles: true,
                        cancelable: true,
                      });
                      inputRef.current.dispatchEvent(event);
                    }}
                    size="small"
                    tabIndex={-1}
                  >
                    <CloseIcon sx={{ scale: 0.8 }} />
                  </IconButton>
                )}
                <IconButton
                  component="label"
                  tabIndex={-1}
                  size="small"
                  sx={{ flexShrink: 0 }}
                >
                  <CloudUploadIcon />
                  <input
                    type="file"
                    multiple
                    hidden
                    ref={inputRef}
                    disabled={field.disabled}
                    onChange={handleChange}
                  />
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
    </div>
  );
};

export default CustomFileField;
